export default __webpack_public_path__ + "static/media/logo.b4a6eb30.svg";